var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageHealthIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.847,
    height: 46.167,
    viewBox: "0 0 40.847 46.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M225.491,200.118a.9.9,0,0,0-.9-.9h-7.939a.9.9,0,1,0,0,1.8h7.939A.9.9,0,0,0,225.491,200.118Zm0,0",
    transform: "translate(-196.338 -181.252)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M69.781,99.125H68.109a1.87,1.87,0,0,0-1.869,1.866v.869h-.87a1.871,1.871,0,0,0-1.87,1.869V105.4a1.871,1.871,0,0,0,1.87,1.869h.87v.869a1.871,1.871,0,0,0,1.869,1.869h1.673a1.871,1.871,0,0,0,1.87-1.869v-.869h.87A1.871,1.871,0,0,0,74.39,105.4v-1.674a1.871,1.871,0,0,0-1.869-1.869h-.87v-.869A1.87,1.87,0,0,0,69.781,99.125Zm2.739,4.54a.067.067,0,0,1,.064.064V105.4a.066.066,0,0,1-.064.063H70.748a.9.9,0,0,0-.9.9v1.771a.067.067,0,0,1-.064.064H68.109a.066.066,0,0,1-.064-.064v-1.771a.9.9,0,0,0-.9-.9H65.369a.066.066,0,0,1-.064-.063v-1.674a.067.067,0,0,1,.064-.064h1.772a.9.9,0,0,0,.9-.9v-1.771a.066.066,0,0,1,.064-.061h1.673a.066.066,0,0,1,.064.061v1.771a.9.9,0,0,0,.9.9Zm0,0",
    transform: "translate(-57.819 -90.187)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M225.884,140.391a.9.9,0,0,0-.9-.9h-8.333a.9.9,0,0,0,0,1.805h8.333A.9.9,0,0,0,225.884,140.391Zm0,0",
    transform: "translate(-196.338 -126.911)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M71.125,260.716H91.79a.9.9,0,0,0,0-1.805H71.125a.9.9,0,1,0,0,1.805Zm0,0",
    transform: "translate(-63.936 -235.565)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M40.581,28.514a23.057,23.057,0,0,1-5.18-1.305V19.361a.9.9,0,1,0-1.805,0v6.853a4.46,4.46,0,0,1-.537-.478.9.9,0,0,0-1.311,0c-1.2,1.264-3.728,2.2-7.525,2.778a.9.9,0,0,0-.459.215H7.69a.9.9,0,1,0,0,1.8H23.456v3.578H7.084a.9.9,0,1,0,0,1.8H23.529a11.35,11.35,0,0,0,3.137,6.29H4.879a2.574,2.574,0,0,1-2.573-2.568V6.367A2.574,2.574,0,0,1,4.879,3.8H9.187v.335a1.66,1.66,0,0,0,1.66,1.657H25.055a1.66,1.66,0,0,0,1.66-1.657V3.8h4.308A2.574,2.574,0,0,1,33.6,6.367v5.794a.9.9,0,1,0,1.8,0V6.367a4.381,4.381,0,0,0-4.378-4.374H26.714V1.657A1.66,1.66,0,0,0,25.055,0H10.846a1.66,1.66,0,0,0-1.66,1.657v.337H4.879A4.381,4.381,0,0,0,.5,6.367v33.27a4.381,4.381,0,0,0,4.378,4.374H28.6c1.625,1.394,2.628,2.155,3.792,2.156h0c1.31,0,2.413-.955,4.414-2.685,2.828-2.448,4.352-5.24,4.531-8.3,0-.017,0-.035,0-.052V29.406a.9.9,0,0,0-.767-.892ZM10.992,1.805H24.909v2.18H10.992Zm28.55,33.3a10.122,10.122,0,0,1-3.909,7.012c-1.563,1.352-2.6,2.245-3.233,2.245h0c-.633,0-1.61-.846-3.227-2.245A10.133,10.133,0,0,1,25.261,35.1v-4.93c3.3-.568,5.653-1.424,7.142-2.6a8.826,8.826,0,0,0,1.647,1.007.886.886,0,0,0,.128.06,21.485,21.485,0,0,0,5.364,1.533Zm0,0",
    transform: "translate(-0.501 0)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M311.267,360.185,309.68,358.7a.9.9,0,0,0-1.235,1.317l2.256,2.116a.9.9,0,0,0,.617.244h.036a.9.9,0,0,0,.632-.294l4.576-5.03a.9.9,0,0,0-1.335-1.215Zm0,0",
    transform: "translate(-280.418 -323.479)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M368.434,164.6a.9.9,0,0,0-.9.9v.015a.9.9,0,0,0,1.805,0V165.5A.9.9,0,0,0,368.434,164.6Zm0,0",
    transform: "translate(-334.436 -149.76)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageHealthIcon);
export default __webpack_public_path__ + "static/media/login-page-health-icon.caa45fe70d28e18a18cdf8d05be3bca0.svg";
export { ForwardRef as ReactComponent };